import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import chataLogo from './jilovanka-logo-complete.png';
import { FaBars, FaTimes, FaHome, FaCamera, FaGamepad, FaMoneyBillWave, FaUsers, FaTools } from 'react-icons/fa'
import './navbar.css'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  const navigationItems = [
    { to: '/', label: 'ÚVOD', icon: FaHome },
    { to: '/aktivity', label: 'AKTIVITY', icon: FaGamepad },
    { to: '/galerie', label: 'FOTOGALERIE', icon: FaCamera },
    { to: '/cenik', label: 'CENÍK', icon: FaMoneyBillWave },
    { to: '/obsazenost', label: 'OBSAZENOST', icon: FaUsers },
    { to: '/vybaveni', label: 'VYBAVENÍ', icon: FaTools }
  ]

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMenu = () => setIsOpen(!isOpen)

  return (
    <motion.nav 
      className={`navbar ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={chataLogo} alt="Chata Jílovanka" className="logo-img" />
        </Link>

        <div className="nav-menu">
          {navigationItems.map((item, index) => {
            const Icon = item.icon
            const isActive = location.pathname === item.to
            
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`nav-link ${isActive ? 'active' : ''}`}
              >
                <Icon className="nav-icon" />
                <span>{item.label}</span>
              </Link>
            )
          })}
          <a href="#kontakt" className="nav-link">
            <span>KONTAKT</span>
          </a>
        </div>

        <div className="nav-toggle" onClick={toggleMenu}>
          <motion.div
            className="hamburger"
            animate={{ rotate: isOpen ? 45 : 0 }}
            transition={{ duration: 0.3 }}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </motion.div>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="mobile-menu-content">
              {navigationItems.map((item, index) => {
                const Icon = item.icon
                const isActive = location.pathname === item.to
                
                return (
                  <motion.div
                    key={item.to}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <Link
                      to={item.to}
                      className={`mobile-nav-link ${isActive ? 'active' : ''}`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Icon className="mobile-nav-icon" />
                      <span>{item.label}</span>
                    </Link>
                  </motion.div>
                )
              })}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: navigationItems.length * 0.1 }}
              >
                <a 
                  href="#kontakt" 
                  className="mobile-nav-link"
                  onClick={() => setIsOpen(false)}
                >
                  <span>KONTAKT</span>
                </a>
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  )
}

export default Navbar
